/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_SpeakersInputs */

const en_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Speakers`)
};

const fr_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervenants du projet`)
};

const de_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektsprecher`)
};

const it_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatori del progetto`)
};

const ru_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спикеры проекта`)
};

const es_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponentes del proyecto`)
};

const zh_cn2_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目发言人`)
};

const ja_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトスピーカー`)
};

const hi_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना वक्ता`)
};

const pt_pt2_project_speakers = /** @type {(inputs: Project_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestrantes do Projeto`)
};

/**
* | output |
* | --- |
* | "Project Speakers" |
*
* @param {Project_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_speakers = /** @type {((inputs?: Project_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_speakers(inputs)
	if (locale === "de") return de_project_speakers(inputs)
	if (locale === "it") return it_project_speakers(inputs)
	if (locale === "ru") return ru_project_speakers(inputs)
	if (locale === "es") return es_project_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_project_speakers(inputs)
	if (locale === "ja") return ja_project_speakers(inputs)
	if (locale === "hi") return hi_project_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_project_speakers(inputs)
	return en_project_speakers(inputs)
});